import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const GAMESHOW_REPOSITORY = new InjectionToken<GameShowRepository>('GAMESHOW_REPOSITORY');

export interface GameShowRepository {
  getActiveGameShowActivityId(classId: string): Observable<string | null>;
}
